import * as CryptoJS from 'crypto-js'

export class Facebook {
  private id: string
  private active: boolean
  private fbq?: any
  private promise?: Promise<any>

  constructor(id: string, active?: boolean) {
    this.id = id
    this.active = active!
  }

  public pageView(eventName: string, params: object) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          this.fbq('track', 'PageView')
          resolve('PageView')
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  }

  public track(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          if (
            ['AddToCart', 'ViewContent', 'Purchase', 'Lead'].includes(eventName)
          ) {
            this.fbq('track', eventName, data)
          } else {
            this.fbq('trackCustom', eventName, data)
          }
          resolve(data)
        })
        .catch(err => {
          console.error(err)
          reject(err)
        })
    })
  }

  public identify(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load().then(() => {
        if (data.email !== undefined) {
          const email = CryptoJS.SHA256(data.email.toLowerCase().trim())
            .toString()
            .substr(0, 32)
          this.fbq('init', this.id, {
            em: email,
          })
          resolve({ em: email })
        }
        resolve('No email present')
      })
    })
  }

  private _load() {
    return (
      this.promise ||
      (this.promise = new Promise((resolve, reject) => {
        if (this.fbq) {
          resolve(this.fbq)
        } else {
          const script = document.createElement('script')

          script.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
                        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
                        document,'script','https://connect.facebook.net/en_US/fbevents.js');`
          document.head.appendChild(script)

          this.fbq = (window as any).fbq
          this.fbq('init', this.id)
          resolve(this.fbq)
        }
      }))
    )
  }
}
